export default __webpack_public_path__ + "static/media/logwalls.53d71918.png";